import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            飞飞漫画网为你打造极致漫画全集阅读体验的核心优势
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto">
          {featuresData.map((feature) => (
            <div key={feature.id} className="bg-background-50 rounded-lg p-6 md:p-8 text-center group hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-accent-100/80 rounded-lg mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}